














































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetDistrictList, InsertDistrict, UpdateDistrictById, DeleteDistrict, GetProvinceList, GetCityByProvList} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
@Component
export default class Country extends AbpBase {
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {
		// cityId
	}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	provs = []	//省下拉集合
	citys = []	//市下拉集合
	tableLoading = false
	created() {
		this.getData()
		this.getProvs()
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
			(this.$refs.form as any).resetFields()
		}
	}
	columns = [
		{
			key: 'provName',
			title: '所属省'
		},
		{
			key: 'cityName',
			title: '所属市'
		},
		{
			key: 'distName',
			title: '区名称'
		},
		{
			key: 'distPY',
			title: '拼音助记符'
		},
		{
			key: 'distWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.distPY = res1
		this.dialogForm.distWB = res2
	}
	//获取所有省 => 下拉
	private async getProvs(){
		let res = await GetProvinceList({
			SkipCount: 1,
			MaxResultCount: 10000
		})
		this.provs = res.items
	}
	private async getCitys(val: any){
		this.citys = [];
		// this.dialogForm.cityId = 0
		let res = await GetCityByProvList({Id: val})
		this.citys = res
	}
	createCounty() {
		this.dialogTitle = '新增区'
		this.dialogForm = {status:true,distPY:'',distWB:''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetDistrictList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.getCitys(row.provId)
		this.dialogTitle = '编辑区'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteDistrict({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				this.provs.forEach((item: any) => {
					if (item.id === this.dialogForm.provId)	{
						this.dialogForm.provName = item.provName
					}
				})
				this.citys.forEach((item:any) => {
					if (item.id === this.dialogForm.cityId) {
						this.dialogForm.cityName = item.cityName
					}
				})
				if (this.dialogTitle === '新增区') {
					let res = await InsertDistrict(this.dialogForm)
				} else if (this.dialogTitle === '编辑区') {
					let res = await UpdateDistrictById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}
	rules = {
		provId:[{required: true, message: '请输入内容', trigger: 'blur'}],
		distName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		distPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		distWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/basicDictionary/district/index.vue